<h1 mat-dialog-title>Presupuestos vigentes</h1>
<div mat-dialog-content>
  <div
    style="max-height: 200px; overflow-y: scroll"
    class="card-content margin-botton-medium"
  >
    <mat-spinner *ngIf="loading"></mat-spinner>
    <table
      *ngIf="!loading"
      class="search-table"
      mat-table
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>

        <td mat-cell *matCellDef="let element">
          <div>
            <b>{{ element.Name }}</b>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Date">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let element">
          <div>{{ element.Date | date : "dd/MM/yyyy" }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="FinalizeDate">
        <th mat-header-cell *matHeaderCellDef>Vencimiento</th>
        <td mat-cell *matCellDef="let element">
          <div>{{ element.FinalizeDate | date : "dd/MM/yyyy" }}</div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        class="search-table-header"
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></tr>
      <tr
        (click)="asociateBudget(row)"
        mat-row
        class="search-table-cell"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
      Cancelar
    </button>
  </div>
</div>
